import api from "./Axios.js";

export const registerAdmin = async (data) => {
  try {
    const res = await api.post("/register-admin", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const siginAdmin = async (data) => {
  try {
    const res = await api.post("/login-admin", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ForgotAdminPassword = async (data) => {
  try {
    const res = await api.post("/admin/reset-password", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ResetAdminPassword = async (id, data) => {
  try {
    const res = await api.patch(`/change-admin-password/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllAdmins = async (id) => {
  try {
    const response = await api.get(`/admins`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const ViewAdminDetails = async (id) => {
  try {
    const response = await api.get(`/admin/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const EditAdminProfile = async (adminId, data) => {
  try {
    const response = await api.put(`/admin-profile/${adminId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const ChangeAdminPassword = async (id, data) => {
  try {
    const response = await api.patch(`/change-password/${id}`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createCartegory = async (adminId, data) => {
  try {
    const response = await api.post(`/create-category/${adminId}`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const addCategory = async (data) => {
  try {
    const response = await api.post(`/add-category`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const getCategories = async (search, size) => {
  try {
    const url = search
      ? `/categories?search=${search}&size=${size}`
      : `/categories`;
    // const url = `/categories`;
    // url = search && (url + `?search=${search}`);
    // url = size && (url + `?size=${size}`);
    // url = (search && size) && (url + `?search=${search}&size=${size}`);
    const response = await api.get(url);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const getCategory = async (categoryId) => {
  try {
    const response = await api.get(`/category/${categoryId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const updateSubCategory = async (data) => {
  try {
    const response = await api.post(`/subcategory/${data.categoryId}`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const updateCategory = async (data) => {
  try {
    const response = await api.post(`/category/${data.categoryId}`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const checkCategoryProducts = async (categoryId) => {
  try {
    const response = await api.get(`/check-category-products/${categoryId}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const checkSubcategoryProducts = async (categoryId, subCategoryId) => {
  try {
    const response = await api.get(`/check-subcategory-products/${categoryId}/${subCategoryId}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteCategory = async (data) => {
  try {
    const response = await api.delete(`/delete-category/${data.categoryId}`, {
      data: { destinationCategoryId: data.destinationCategoryId }
    });
    console.log(response)
    return response;
  } catch (err) {
    throw err;
  }
};
export const deleteSubCategory = async (data) => {
  try {
    const response = await api.delete(`/subcategory/${data.categoryId}`, {
      data: data
    });
    console.log(response)
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const getTransactions = async () => {
  try {
    const response = await api.get("/transactions");
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const getTransaction = async (transactionId) => {
  try {
    const response = await api.get(`/transaction/${transactionId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const addSubCategoryAndBrand = async (data) => {
  try {
    const response = await api.post(
      `/subcategorybrand/${data.categoryId}`,
      data,
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const AdminViewSingleCategory = async (adminId) => {
  try {
    // const response = await api.get(`/category-by-admin/${adminId}`);
    const response = await api.get(`/category-by-admin`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const RemoveSingleCartegories = async (categoryId, token) => {
  try {
    const response = await api.delete(`/delete-category/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminCreateBrand = async (adminId, data) => {
  try {
    const response = await api.post(`/create-brand/${adminId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const ViewAdminBrands = async (adminId, token) => {
  try {
    const response = await api.get(`/brand-by-admin/${adminId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminSearchBrands = async (searchTerm, token) => {
  try {
    const response = await api.get(`/brands/search?name=${searchTerm}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminCreateProducts = async (adminId, data) => {
  try {
    const response = await api.post(`/create-product/${adminId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(response);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminViewAllProducts = async (adminId) => {
  try {
    const response = await api.get(`/product-by-admin/${adminId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AllAdminProducts = async () => {
  try {
    const response = await api.get("/all-product");
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminDeleteAProduct = async (productId) => {
  try {
    const response = await api.delete(`/delete-product/${productId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminViewSingleProduct = async (productId) => {
  try {
    const response = await api.get(`/single-product/${productId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminUpdateSingleProduct = async (productId, data) => {
  try {
    const response = await api.put(`/update-product/${productId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 201) {
      response.data.status = 200;
    }
    return response.data;
  } catch (err) {
    throw err;
  }
};
export const AdminUpdateSingleCategory = async (categoryId, data) => {
  try {
    const response = await api.put(`/update-category/${categoryId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const AdminViewAllOrders = async () => {
  try {
    const response = await api.get(`/all-order`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateOrder = async (orderId, updateData) => {
  try {
    const response = await api.put(`/orders/${orderId}`, updateData);

    return response.data;
  } catch (error) {
    console.error("Error updating order:", error);
    throw error;
  }
};

export const AdminViewSingleOrderByUserId = async (userId) => {
  try {
    const response = await api.get(`/orders/${userId}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const AdminViewSingleOrder = async (orderId) => {
  try {
    const response = await api.get(`/order/${orderId}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const AdminAllCustomers = async () => {
  try {
    const response = await api.get(`/users`);

    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const AdminOneCustomer = async (userId) => {
  try {
    const response = await api.get(`/user/${userId}`);

    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const DeactivateCustomer = async (userId) => {
  try {
    const response = await api.get(`/deactivate-account/user/${userId}`);

    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const DeactivateAdmin = async (adminId) => {
  try {
    const response = await api.post(`/deactivate-account`, { adminId });
    return response;
  } catch (err) {
    throw err;
  }
};

export const ActivateCustomer = async (userId) => {
  try {
    const response = await api.post(`/activate-account/user/${userId}`);

    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const ActivateAdmin = async (adminId) => {
  try {
    const response = await api.get(`/activate-account`, { adminId });

    return response;
  } catch (err) {
    throw err;
  }
};

export const GetDeliveryInfo = async (data) => {
  try {
    const response = await api.get("delivery", data);
    return response?.data;
  } catch (err) {
    // ShowToast(false, `${err.response.data.message}`);
    throw err;
  }
};

export const AddDeliveryInfo = async (data) => {
  try {
    const response = await api.post("delivery", data);
    return response;
  } catch (err) {
    // ShowToast(false, `${err.response.data.message}`);
    throw err;
  }
};

export const UpdateDeliveryInfo = async (id, data) => {
  try {
    const response = await api.put(`delivery/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
};

export const DeleteDeliveryInfo = async (id, data) => {
  try {
    const response = await api.delete(`delivery/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
};

export const SubmitBNPL = async (data) => {
  try {
    const response = await api.post("/order/bnpl", data);
    if (response.status === (201 || 204)) {
      response.success = true;
    }

    return response;
  } catch (err) {
    throw err;
  }
};

export const getAllBNPL = async () => {
  try {
    const response = await api.get("/order/bnpl");

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getBanners = async () => {
  try {
    const response = await api.get("banners");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postBanner = async (formData) => {
  try {
    const response = await api.post("/banners", formData);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBanner = async (id, formData) => {
  try {
    const response = await api.put(`/banners/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBanner = async (id) => {
  try {
    await api.delete(`/banners/${id}`);
    return { success: true };
  } catch (error) {
    throw error;
  }
};

export const GetAllEvents = async () => {
  try {
    const response = await api.get("/track");
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const GetAllCarts = async () => {
  try {
    const response = await api.get("/cart");

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const SendEmail = async (email) => {
  try {
    const response = await api.post("/send-reminder-email", { email: email });
    return response;
  } catch (err) {
    throw err;
  }
};

export const SendBulkEmails = async () => {
  try {
    const response = await api.post("/send-bulk-reminder-emails");
    return response;
  } catch (err) {
    throw err;
  }
};

export const getHomeLayout = async () => {
  try {
    const response = await api.get("/product/home/layout");
    return response.data;
  } catch (err) {
    console.error(
      "Failed to load layouts:",
      err.response?.data?.message || err.message,
    );
    throw err;
  }
};

export const saveHomeLayout = async (id, sections) => {
  try {
    const response = await api.put(`/product/home/${id}`, { sections });
    return response.data;
  } catch (err) {
    console.error("Save failed:", err.response?.data?.message || err.message);
    throw err;
  }
};
